// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__1fJ_H","slider-glide-in":"Sidebar_slider-glide-in__2whNK"};